export default __webpack_public_path__ + "static/evitat-logo-white-a76c204fd0ba29d971c9fb6a74d125dc.png";